'use client';

import type { PromotionBanner } from '@/types';

import React from 'react';

import { Box, Button, Container, Image, Link, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';

const CallToAction: React.FC<{ promotionBanners: PromotionBanner[] }> = ({
  promotionBanners,
}) => {
  const { t } = useTranslation('pages.home');

  return (
    <Container py={{ base: 5, md: 2.5 }}>
      <Stack gap={4}>
        {promotionBanners.map((data) => (
          <Box
            display="flex"
            justifyContent="center"
            flexDir={{ base: 'column', md: 'row' }}
            key={data.id}
            bg="gray.250"
            borderRadius="xs"
            gap={2.5}
          >
            <Box
              display={{ base: 'block', md: 'none' }}
              position="relative"
              width="100%"
              borderRadius="xs"
              overflow="hidden"
              sx={{
                img: {
                  borderRadius: '8px',
                },
              }}
            >
              <Image
                src={data.portrait_image}
                alt={data.alt_image}
                width={705}
                height={478}
              />
            </Box>
            <Box
              w={{ base: '100%', md: '50%' }}
              p={6}
              display="flex"
              justifyContent="center"
              flexDir="column"
              gap="44px"
            >
              <Text fontWeight={700} fontSize="34px">
                {data.title}
              </Text>
              <Text fontWeight={400} fontSize="md" lineHeight="37px" mt="-4">
                {data.description}
              </Text>
              {data.link && (
                <Link href={data.link} prefetch={false}>
                  <Button variant="outline">{t('readMore')}</Button>
                </Link>
              )}
            </Box>
            <Box
              display={{ base: 'none', md: 'block' }}
              position="relative"
              width="50%"
              borderRadius="xs"
              overflow="hidden"
              sx={{
                img: {
                  borderRadius: '8px',
                },
              }}
            >
              <Image
                src={data.portrait_image}
                alt={data.alt_image}
                width={705}
                height={478}
              />
            </Box>
          </Box>
        ))}
      </Stack>
    </Container>
  );
};
export default CallToAction;
